<template>
  <div class="control">
    <div class="control__title">
      <div class="title">
        <div class="title-text">
          {{ title }}
        </div>
      </div>
    </div>
    <div class="control__action">
      <div class="control__choice">
        <div
          class="fakeoverlay"
          :class="{disabled: !selectStatus}"
          @click="selectStatus =! selectStatus"
        />
        <div
          class="imageoptions"
        >
          <div
            v-for="(item, i) in src.filter(e => this.type.includes(e.value))"
            :key="i"
            class="imageoptions__item"
            :class="{'active': i === active && selectStatus === true}"
            @click="changeImage(i)"
          >
            <img :src="item.url">
          </div>
        </div>
      </div>
      <el-checkbox
        v-model="selectStatus"
        class="control__checkbox"
        @change="changeOptionCSS"
      />
    </div>
  </div>
</template>

<script>
import src from '@/assets/hint_images.json'
import { mapState } from 'vuex'
export default {
  name: 'HintIconCSS',
  props: {
    title: {
      type: String,
      default: ''
    },
    default: {
      type: Number,
      default: 0
    },
    hint: {
      type: String,
      default: ''
    },
    type: {
      type: Array
    },
    status: {
      type: Boolean
    },
    parameter: {
      type: String,
      default: ''
    },
    eventClick: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      src: src,
      value: src[this.default],
      active: this.default,
      selectStatus: this.status,
      showHint: false
    }
  },
  computed: {
    ...mapState(['clearOptionsCSS'])
  },
  watch: {
    clearOptionsCSS (val) {
      if (val) {
        this.selectStatus = false
      }
    },
    eventClick (val) {
      if (val) {
        this.value = src[this.default].value
        this.active = this.default
        this.selectStatus = val
        this.changeImage(this.active)
      }
    },
    selectStatus (val) {
      if (val === true) {
        this.changeImage(this.active)
        this.changeOptionCSS()
      }
    }
  },
  methods: {
    changeImage (i) {
      this.active = i
      this.value = this.src[i].value
      this.changeOptionCSS()
    },
    changeOptionCSS () {
      const value = this.selectStatus === true ? `block` : ''
      this.$emit('changeOptionCSS', {
        type: 'hinticons',
        hiddenType: `${this.value}`,
        parameter: `${this.parameter}`,
        separator: ':',
        value: `${value}`
      })
    }
  }
}
</script>

<style lang="scss" scoped>
  .imageoptions {
    width: 100%;
    max-width: 340px;
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-start;

    &__item{
      display: flex;
      width: 50%;
      max-width: 130px;
      justify-content: center;
      align-items: center;
      text-align: center;
      margin: 0 2.5px 5px;
      cursor: pointer;
      padding: 5px;
      border: 1px solid transparent;

      img {
        max-width: 100%;
        width: 100%;
      }

      &.active {
        border-radius: 4px;
        border: 1px solid rgba(50, 123, 186, 0.9);
        //box-shadow: 0 8px 40px rgba(50, 123, 186, 0.16), 0 4px 4px rgba(50, 123, 186, 0);
      }
    }
  }
</style>
